import { useState } from "react";
import { TableCell } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { toast } from "react-toastify";
import { Button, Modal, TextInput } from "src/Components";
import { IAssetLimitTableReport } from "src/Interfaces/portfolioGroups";
import { editPortfoGroupAssetLimit } from "src/Requests/portfolioGroups";
import { IAdditional } from "src/Tables/TableTemplate/tableTemplate";
import { packetErrorHandler } from "src/Utils/requestUtils";

const AdditionalHeader: React.FC = () => <TableCell />;

const AdditionalCol: React.FC<{
  row: IAssetLimitTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState({
    minValue: row.minValue ?? 0,
    maxValue: row.maxValue ?? 0,
  });

  const onChange = (name: string, value: string | number) => {
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const openModal = () => {
    setFormValues({
      minValue: row.minValue ?? 0,
      maxValue: row.maxValue ?? 0,
    });
    setModalOpen(true);
  };

  const closeModal = () => setModalOpen(false);

  const submitHandler = () => {
    setLoading(true);
    editPortfoGroupAssetLimit({
      PortfoGroupAssetLimitId: row.id,
      MinValue: Number(formValues.minValue) || 0,
      MaxValue: Number(formValues.maxValue) || 0,
    })
      .then((resp) => {
        if (!resp.data) toast.error(resp.msg);
        else {
          toast.success(resp.msg);
          onAction();
          closeModal();
        }
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const editModalUI = (
    <div className="flex flex-col justify-start items-start gap-4 min-w-[360px] p-2">
      <TextInput
        name="assetTypeName"
        label="طبقه دارایی / استراتژی"
        extraLabel
        onChange={onChange}
        value={row.assetTypeName}
        disabled
      />
      <TextInput
        name="minValue"
        label="٪ کف"
        extraLabel
        onChange={onChange}
        value={formValues.minValue.toString()}
      />
      <TextInput
        name="maxValue"
        label="٪ سقف"
        extraLabel
        onChange={onChange}
        value={formValues.maxValue.toString()}
      />
      <Button
        text="ویرایش"
        onClick={submitHandler}
        variant="contained"
        loading={loading}
      />
    </div>
  );

  return row.id ? (
    <>
      {modalOpen && (
        <Modal
          onClose={closeModal}
          UI={editModalUI}
          modalBoxClassName="!min-w-min"
        />
      )}
      <TableCell>
        <div className="w-min mx-auto">
          <div
            className="hover:bg-slate-300 transition-all rounded p-1"
            onClick={openModal}
          >
            <EditIcon className="text-sky-700 cursor-pointer" />
          </div>
        </div>
      </TableCell>
    </>
  ) : null;
};

export const getAssetLimitAdditional = (
  onEditSuccess: () => void,
): IAdditional<IAssetLimitTableReport> => ({
  getHeader: AdditionalHeader,
  getRow: ({ row, onAction }) => (
    <AdditionalCol
      row={row}
      onAction={() => {
        onAction();
        onEditSuccess();
      }}
    />
  ),
});
